<template>
  <div class="tab-wrapper">
    <ul class="nav nav-tabs" role="tablist">
      <li role="presentation"
        v-for="(tab, index) in tabs"
        :class="[tab.tabClass, { 'active': tab.isActive }]"
        :key="index">
        <a :href="tab.href" @click.prevent="selectTab(tab)">
          <img class="flag" src="/static/img/flag-en.png" v-if="tab.name === 'English'">
          <img class="flag" src="/static/img/flag-id.png" v-if="tab.name === 'Indonesia'">
          {{ tab.name }}
        </a>
      </li>
    </ul>

    <div class="tab-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tabs: [],
    };
  },

  methods: {
    selectTab(selectedTab) {
      this.tabs.forEach((tab) => {
        tab.isActive = (tab.href === selectedTab.href);
      });
    },
  },

  created() {
    this.tabs = this.$children;
  },
};
</script>

<style lang="scss" scoped>
  .nav-tabs {
    border-bottom: none;

    li a {
      padding: 3px 10px;
      font-size: 10px;
      text-transform: uppercase;
    }
  }

  .flag {
    display: inline-block;
    height: 18px;
    margin-right: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/modules/products/partials/LanguageTabs.vue